import { render, staticRenderFns } from "./economic-production-pavilion.vue?vue&type=template&id=2f0b0ed0&scoped=true"
import script from "./economic-production-pavilion.vue?vue&type=script&lang=js"
export * from "./economic-production-pavilion.vue?vue&type=script&lang=js"
import style0 from "./economic-production-pavilion.vue?vue&type=style&index=0&id=2f0b0ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b0ed0",
  null
  
)

export default component.exports